import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import googlePlay from "../assets/play.svg";
import appStore from "../assets/apple.svg";
import mechanicAppImage from "../assets/carmie-phoneMechanic.png";
import bgImage from "../assets/home4.png";

export default function MechanicApp() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <div
        className="relative min-h-screen flex flex-col lg:flex-row items-center justify-center px-6 lg:px-20 py-24"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Content */}
        <div className="relative z-10 text-center lg:text-left max-w-2xl text-white">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold">
            Join Carmie as a Mechanic
          </h1>
          <p className="text-base md:text-lg mt-4">
            Sign up as a professional mechanic and start getting job requests
            from car owners near you. Earn money, work on your schedule, and
            grow your business!
          </p>
          <p className="text-lg font-semibold text-[#D6F7C6] mt-4">
            Partner app access is opening soon.
          </p>

          {/* Download Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center mt-6 space-y-4 sm:space-y-0 sm:space-x-4">
            <a
              href="https://play.google.com/store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={googlePlay}
                alt="Google Play Store"
                className="w-40 transition hover:scale-105"
              />
            </a>
            <a
              href="https://www.apple.com/app-store/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={appStore}
                alt="Apple App Store"
                className="w-40 transition hover:scale-105"
              />
            </a>
          </div>

          {/* Go Back Button */}
          <button
            onClick={() => {
              navigate("/");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="mt-6 px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition"
          >
            Back to Carmie
          </button>
        </div>

        {/* Right Side - Image */}
        <div className="relative z-10 mt-10 lg:mt-0 lg:ml-16">
          <img
            src={mechanicAppImage}
            alt="Mechanic App Preview"
            className="w-full max-w-[90%] sm:max-w-md rounded-lg shadow-lg"
          />
        </div>
      </div>
    </>
  );
}
